import { createFileRoute } from "@tanstack/react-router";
import { DiscoverSectionPage } from "../../../features/discover/pages/discover-section-page";

/** The trips themselves, in the Discover shell. */
export const Route = createFileRoute("/$lang/_layout/trips")({
  component: () => (
    <DiscoverSectionPage
      mode="trips"
      canonicalOf="trip-planner"
      titleKey="trip_planner_page.seo_title"
      descriptionKey="trip_planner_page.seo_description"
    />
  ),
});
